import { render } from "./Mybutton.vue?vue&type=template&id=c0f6fe04&scoped=true"
import script from "./Mybutton.vue?vue&type=script&lang=js"
export * from "./Mybutton.vue?vue&type=script&lang=js"

import "./Mybutton.vue?vue&type=style&index=0&id=c0f6fe04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0f6fe04"

export default script